module.exports = __webpack_public_path__ + "static/SuperbikeWhite-27dfe02274616bf16a9bdaf3be4923da.mp4";